import { useThemeData } from '@msrceng/theme';
/** Get the background color for the appbar */
export const useAppBarColor = () => {
    const { isDarkMode, theme } = useThemeData();
    const { palette } = theme;
    const color = isDarkMode ? palette.neutralDark : palette.neutralLight;
    const background = isDarkMode ? palette.themeLight : palette.themeDarker;
    return {
        color,
        background,
    };
};
